export const KEYS_HELPERS = {
    GET_ALL_MANAGERS: "GET_ALL_MANAGERS", // get all managers for dropdowns
    GET_ALL_AGENCIES: "GET_ALL_AGENCIES", // get all agencies for dropdowns
};
